(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/icon-text/assets/icon-text.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/icon-text/assets/icon-text.js');
'use strict';

const Icon = svs.ui.ReactIcon;

const IconText = _ref => {
  let children = _ref.children,
    _ref$isPadding = _ref.isPadding,
    isPadding = _ref$isPadding === void 0 ? false : _ref$isPadding,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '300' : _ref$size,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'exclamation-sign' : _ref$icon;
  return React.createElement("div", {
    className: "u-flex ".concat(className, " ").concat(isPadding ? 'padding-top-1' : ''),
    style: {
      alignItems: 'center'
    }
  }, React.createElement("div", {
    className: "u-flex padding-right"
  }, React.createElement(Icon, {
    icon: icon,
    size: size
  })), React.createElement("div", {
    className: "u-flex"
  }, children));
};
svs.tb_ui_react.icon_text.IconText = IconText;

 })(window);